// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"4078cd5a","623":"c3083d10"}[chunkId] + ".chunk.js";
};